<!-- 
Text field for entering percentage values.
-->
<template>
  <v-text-field
    :value="formattedValue"
    :label="label"
    :rules="[unrestrictedRange ? rules.number : rules.percentage, greaterThanZero ? rules.greaterThanZeroPercentage : rules.empty, required ? rules.required : rules.empty]"
    :autofocus="autofocus"
    :hint="hint"
    :disabled="disabled"
    suffix="%"
    @change="changed"
  >
    <template v-if="hasLabelSlot" slot="label">
      <slot name="label"/>
    </template>
  </v-text-field>
</template>

<script>
import ruleMixins from "@/mixins/rule.mixins";
import * as ruleHelper from "@/helpers/rule.helper";
import * as formatting from "@/helpers/formatting.helper";

export default {
  mixins: [ruleMixins],
  props: {
    value: {
      validator: prop => typeof prop === "number" || typeof prop === "string" || prop === null || prop === undefined,
      required: true
    },
    label: {
      default: "",
      type: String
    },
    required: {
      default: false,
      type: Boolean
    },
    disabled: {
      default: false,
      type: Boolean
    },
    zeroOrGreater: {
      default: false,
      type: Boolean
    },
    greaterThanZero: {
      default: false,
      type: Boolean
    },
    autofocus: {
      default: false,
      type: Boolean
    },
    decimalPlaces: {
      type: Number,
      required: true
    },
    unrestrictedRange: {
      type: Boolean,
      default: false
    },
    hint: {
      type: String,
      default: null
    }
  },
  computed: {
    formattedValue() {
      if (ruleHelper.isEmpty(this.value)) {
        return null;
      } else if (this.rules.number(this.value) !== true) {
        return this.value;
      } else {
        return formatting.numericInput(this.value * 100, this.decimalPlaces);
      }
    },
    hasLabelSlot() {
      return !!this.$slots["label"];
    }
  },
  methods: {
    changed(d) {
      if (d && this.rules.number(d) === true) {
        this.$emit("input", (ruleHelper.getNumber(d) / 100).toFixed(this.decimalPlaces + 2));
      } else {
        this.$emit("input", d);
      }
    }
  }
};
</script>
